/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type ScreenContentTypeEnum = "HTML" | "JSON" | "ROWS" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type Screen_screen$ref: FragmentReference;
export type Screen_screen = {|
  +id: string,
  +index: ?number,
  +rowset: ?{|
    +fields: ?$ReadOnlyArray<?{|
      +name: ?string,
      +label: ?string,
    |}>,
    +rows: ?$ReadOnlyArray<?$ReadOnlyArray<?string>>,
  |},
  +name: ?string,
  +html: ?string,
  +json: ?string,
  +duration: ?number,
  +contentType: ?ScreenContentTypeEnum,
  +dataSource: ?string,
  +$refType: Screen_screen$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "Screen_screen",
  "type": "Screen",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "index",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "rowset",
      "storageKey": null,
      "args": null,
      "concreteType": "RowSet",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "fields",
          "storageKey": null,
          "args": null,
          "concreteType": "FieldDefinition",
          "plural": true,
          "selections": [
            v0,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "label",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "rows",
          "args": null,
          "storageKey": null
        }
      ]
    },
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "html",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "json",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "duration",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contentType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "dataSource",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '23bb50d083028da6dadaf87f226a4195';
module.exports = node;



// WEBPACK FOOTER //
// ./src/scenes/Screen/__generated__/Screen_screen.graphql.js